import React from 'react';
import { motion } from 'framer-motion';
import { FaTruck, FaShieldAlt, FaHeadset, FaMoneyBillWave, FaGift, FaSyncAlt } from 'react-icons/fa';

const features = [
  {
    icon: FaShieldAlt,
    title: 'Genuine Products',
    description: '100% original products with full manufacturer warranty',
    gradient: 'from-blue-500 to-indigo-600',
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    iconColor: '#4f46e5',
  },
  {
    icon: FaTruck,
    title: 'Free Delivery',
    description: 'Free shipping on orders over PKR 50,000 nationwide',
    gradient: 'from-emerald-500 to-teal-600',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    iconColor: '#0d9488',
  },
  {
    icon: FaHeadset,
    title: '24/7 Support',
    description: 'Dedicated customer support team always ready to help',
    gradient: 'from-violet-500 to-purple-600',
    bg: 'bg-violet-50 dark:bg-violet-900/20',
    iconColor: '#7c3aed',
  },
  {
    icon: FaMoneyBillWave,
    title: 'Best Price',
    description: 'Competitive prices guaranteed across the market',
    gradient: 'from-amber-500 to-orange-600',
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    iconColor: '#d97706',
  },
  {
    icon: FaSyncAlt,
    title: 'Easy Returns',
    description: '7-day hassle-free return and exchange policy',
    gradient: 'from-rose-500 to-pink-600',
    bg: 'bg-rose-50 dark:bg-rose-900/20',
    iconColor: '#e11d48',
  },
  {
    icon: FaGift,
    title: 'Special Offers',
    description: 'Exclusive deals, bundles and seasonal discounts',
    gradient: 'from-cyan-500 to-blue-600',
    bg: 'bg-cyan-50 dark:bg-cyan-900/20',
    iconColor: '#0891b2',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-24 relative overflow-hidden why-choose-section">
      {/* Background accents */}
      <div className="absolute top-0 left-1/4 w-72 h-72 bg-primary-100/40 dark:bg-primary-900/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-100/30 dark:bg-indigo-900/10 rounded-full blur-3xl" />

      <div className="container-custom relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-flex items-center gap-2 text-primary-600 dark:text-primary-400 font-semibold text-sm mb-4 tracking-wide uppercase">
            Why Choose Us
          </span>
          <h2 className="section-title">What Makes Us Different</h2>
          <p className="section-subtitle">We provide the best service, quality products, and unbeatable customer experience</p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                viewport={{ once: true }}
                className="group bg-white dark:bg-slate-900/80 rounded-2xl p-7 border border-slate-100 dark:border-slate-800 hover:border-slate-200 dark:hover:border-slate-700 hover:shadow-xl hover:shadow-slate-200/50 dark:hover:shadow-slate-900/50 transition-all duration-400 hover:-translate-y-1"
              >
                <div className={`w-14 h-14 ${feature.bg} rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="text-xl" style={{ color: feature.iconColor }} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{feature.title}</h3>
                <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;